var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Actions/map",
    clipPath: "url(#clip0_2255_4663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62746 0.849467C5.845 0.725158 6.11027 0.717794 6.33438 0.829846L11.9757 3.65049L16.8775 0.849467C17.1094 0.716935 17.3943 0.717886 17.6254 0.851965C17.8564 0.986044 17.9986 1.23298 17.9986 1.5001V13.5001C17.9986 13.769 17.8545 14.0173 17.621 14.1507L12.371 17.1507C12.1535 17.275 11.8882 17.2824 11.6641 17.1704L6.02283 14.3497L1.12104 17.1507C0.889108 17.2833 0.604162 17.2823 0.373119 17.1482C0.142077 17.0142 -0.00012207 16.7672 -0.00012207 16.5001V4.5001C-0.00012207 4.23119 0.143972 3.98289 0.377457 3.84947L5.62746 0.849467ZM6.02283 2.34972L1.49862 4.93498V15.2088L5.62746 12.8495C5.845 12.7252 6.11027 12.7178 6.33438 12.8298L11.9757 15.6505L16.4999 13.0652V2.7914L12.371 5.15074C12.1535 5.27505 11.8882 5.28241 11.6641 5.17036L6.02283 2.34972Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99988 0.750733C6.41374 0.750733 6.74925 1.08624 6.74925 1.5001V13.5001C6.74925 13.914 6.41374 14.2495 5.99988 14.2495C5.58601 14.2495 5.25051 13.914 5.25051 13.5001V1.5001C5.25051 1.08624 5.58601 0.750733 5.99988 0.750733Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 3.75073C12.4137 3.75073 12.7492 4.08624 12.7492 4.5001V16.5001C12.7492 16.914 12.4137 17.2495 11.9999 17.2495C11.586 17.2495 11.2505 16.914 11.2505 16.5001V4.5001C11.2505 4.08624 11.586 3.75073 11.9999 3.75073Z",
    fill: "#231F20"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2255_4663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c9293a3129a76a9e9096d6832261039e.svg";
export { ForwardRef as ReactComponent };